import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import authService from "../../services/authService.js";
import axios from "axios";
import { api } from "../../services/apiService";

const initialState = {
  dashboardData: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const purchaseSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAll.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.dashboardData = action.payload;
      })
      .addCase(getAll.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.dashboardData = [];
      })
     
  },
});

export const getAll = createAsyncThunk(
  "dashboard/getAll",
  async (data, thunkAPI) => {
    try {
      const responseData = await api.get("/dashboard",{
        params: {
          startDate: data.startDate,
          endDate: data.endDate
        }});
      console.log(responseData);
      return responseData.data;
      // return await authService.login(user);
    } catch (e) {
      const message = e.message;
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { reset } = purchaseSlice.actions;

export default purchaseSlice.reducer;
